module.exports = __webpack_public_path__ + "2eee9616f9a7c0205b3734fe181e7bbd.svg";